export default "__VITE_ASSET__CR2qp4iu__"